import React, { useEffect } from 'react';

const Activation = () => {
  useEffect(() => {
    document.title = 'Karma Experience — Voucher Activation';
  }, []);

  return (
    <div className="w-full min-h-screen bg-[#FBF7EE]">
      <iframe
        src={`/activate.html?t=${Date.now()}`}
        title="Karma Experience Voucher Activation"
        className="w-full min-h-screen border-none block"
        style={{ minHeight: '100vh', width: '100%' }}
      />
    </div>
  );
};

export default Activation;
